import type { MarketOutcome, NormalizedMarket } from 'src/redux/survey/prediction-markets.endpoints';

export const MAX_ATTACHED_MARKETS = 10;

export function formatProbability(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '—';
  }
  return `${Math.round(value * 100)}%`;
}

export function formatCloseDate(value: string | null | undefined): string {
  if (!value) {
    return 'No close date';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'No close date';
  }
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatVolume(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return '—';
  }
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `$${(value / 1_000).toFixed(1)}K`;
  }
  return `$${Math.round(value)}`;
}

export function formatUpdatedAt(value: string | null | undefined): string {
  if (!value) {
    return 'Unknown';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'Unknown';
  }
  return date.toLocaleString();
}

export function topOutcomes(market: NormalizedMarket, limit = 3): MarketOutcome[] {
  const outcomes = market.outcomes ?? [];
  if (!outcomes.length) {
    return [];
  }
  return [...outcomes]
    .sort((left, right) => right.probability - left.probability)
    .slice(0, limit);
}

export function providerLabel(provider: string): string {
  if (provider === 'kalshi') {
    return 'Kalshi';
  }
  if (provider === 'polymarket') {
    return 'Polymarket';
  }
  return provider;
}
